import { q, qq } from "../../helper/q"

export const quantityCompositeInit = () => {
  const quantityElements = qq(".optionsRow")
  if (quantityElements) {
    quantityElements.map(quantityElement => {
      if (quantityElement.classList.contains("optionsRowHeader")) {
        return
      }
      if (quantityElement.classList.contains("optionsRowHeader")) {
        return
      }
      if (q(".optionsBuyMain", quantityElement)) {
        const step = parseFloat(q(".optionsBuyMain", quantityElement).dataset.step)
        const incrementElement = q(".optionsBuyButtonPlus", quantityElement)
        const decrementElement = q(".optionsBuyButtonMinus", quantityElement)
        const choiseButton = q(".optionsChooseButton", quantityElement)
        let value = step
        incrementElement.addEventListener("click", () => {
          value = value + step
          setValue(value, quantityElement)
        })
        decrementElement.addEventListener("click", () => {
          if (value != step) {
            value = value - step
            setValue(value, quantityElement)
          }
        })

        choiseButton.addEventListener("click", () => {
          qq(".optionsChooseButton").forEach(button => {
            button.parentNode.parentNode.classList.remove("optionsCellBuyActive")
          })
          choiseButton.parentNode.parentNode.classList.add("optionsCellBuyActive")
        })
      }
    })
  }
}

const setValue = (value, quantityElement) => {
  const buttons = qq("button[data-productid]", quantityElement)
  const digitElements = qq(".optionsBuyText span", quantityElement)
  buttons.map(button => {
    button.dataset.productquantity = value
  })
  digitElements.map(digitElement => {
    digitElement.innerHTML = value
  })
}
